import apiClient from './apiClient';

export interface SlotInput {
  dayOfWeek: string;
  startTime: string;
  endTime: string;
  slotDurationMinutes?: number;
  capacidadPorSesion?: number;
  zonaHoraria?: string;
}

export interface CreateAvailabilityInput {
  professionalId: string;
  dayOfWeek: string;
  startTime: string;
  endTime: string;
  slotDurationMinutes?: number;
  capacidadPorSesion?: number;
}

export interface Availability {
  id: string;
  professionalId: string;
  dayOfWeek: string;
  startTime: string;
  endTime: string;
  slotDurationMinutes: number;
  breakDurationMinutes: number;
  capacidadPorSesion: number | null;
  isActive: boolean;
  zonaHoraria: string;
  effectiveFrom: string | null;
  effectiveUntil: string | null;
  createdAt: string;
  updatedAt: string;
}

export const availabilityService = {
  getByProfessional: async (professionalId: string): Promise<Availability[]> => {
    const { data } = await apiClient.get<Availability[]>(
      `/professionals/${professionalId}/availability`,
    );
    return data;
  },

  create: async (input: CreateAvailabilityInput): Promise<Availability> => {
    const { data } = await apiClient.post<Availability>(
      `/professionals/${input.professionalId}/availability`,
      input,
    );
    return data;
  },

  batchReplace: async (professionalId: string, slots: SlotInput[], effectiveFrom?: string): Promise<Availability[]> => {
    const { data } = await apiClient.put<Availability[]>(
      `/professionals/${professionalId}/availability`,
      { slots, ...(effectiveFrom ? { effectiveFrom } : {}) },
    );
    return data;
  },
};
